import { AnyAction } from 'redux';

import { carsActions } from '../reducer';

export const resetLocationSharingState = (): AnyAction => carsActions.resetLocationSharing();
